import { Controller, useFormContext } from 'react-hook-form';

import { FormInput, FormLabel, FormRow } from '@ui/components/Form/Form';
import { MdInput } from '@ui/components/MdInput';

import { NewsPost } from '@features/shared/api/typings';

import styles from './ClubNewsItemEditForm.module.css';

export function DescriptionInput() {
  const { control } = useFormContext<NewsPost>();

  return (
    <FormRow>
      <FormLabel>Текст новости</FormLabel>
      <FormInput>
        <Controller
          name="text"
          control={control}
          render={({ field: { value, onChange, disabled } }) => (
            <MdInput
              className={styles.description}
              value={value}
              onChange={onChange}
              disabled={disabled}
            />
          )}
        />
      </FormInput>
    </FormRow>
  );
}
